export default __webpack_public_path__ + "static/media/stripe.e2c4632d.png";